import { Typography } from 'antd';
import { PRIMARY_COLOR } from '../../constants/colors';

const { Paragraph } = Typography;

const FooterLanding = () => (
  <>
    <Paragraph style={{ fontSize: 10, marginBottom: 4 }}>
      Subsecretaría de Minería
      <br />
      Tel.: (0221) 429-5643
      <br />
      Torre Gubernamental II, calle 53 esq 12, Piso 12, La Plata
      <br />
      Email:{' '}
      <a href="mailto:mineria@mp.gba.gov.ar" style={{ color: PRIMARY_COLOR }}>
        mineria@mp.gba.gov.ar
      </a>{' '}
      |{' '}
      <a href="mailto:mineria.gba@gmail.com" style={{ color: PRIMARY_COLOR }}>
        mineria.gba@gmail.com
      </a>
    </Paragraph>
  </>
);

export default FooterLanding;
